module.exports = __webpack_public_path__ + "static/media/RuGuideServiceRecipients.1f29e821.pdf";